import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const data = [
  { monto: "$500.000 CLP", plazo: "3 a 12 meses", tasa: "desde 1% mensual", cae: "Desde 12,68%" },
  { monto: "$1.000.000 CLP", plazo: "6 a 24 meses", tasa: "desde 1% mensual", cae: "Desde 12,68%" },
  { monto: "$3.000.000 CLP", plazo: "12 a 36 meses", tasa: "desde 1% mensual", cae: "Desde 12,68%" },
  { monto: "$5.000.000 CLP", plazo: "12 a 48 meses", tasa: "desde 1% mensual", cae: "Desde 12,68%" },
  { monto: "$10.000.000 CLP", plazo: "24 a 60 meses", tasa: "desde 1% mensual", cae: "Desde 12,68%" },
];

export default function ConditionsTable() {
  return (
    <section
      className="py-20 lg:py-28 bg-white"
      data-testid="conditions-table-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
            Condiciones generales
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Rangos referenciales de crédito
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Los montos y plazos disponibles dependen de cada entidad financiera.
            Bancoorp no garantiza la aprobación ni las condiciones finales.
          </p>
        </div>

        <div className="mt-10 rounded-2xl border border-slate-200 overflow-hidden bg-white shadow-sm">
          <Table data-testid="conditions-table">
            <TableHeader>
              <TableRow className="bg-slate-900 hover:bg-slate-900">
                <TableHead className="text-white font-semibold">Monto</TableHead>
                <TableHead className="text-white font-semibold">Plazo</TableHead>
                <TableHead className="text-white font-semibold">Tasa referencial</TableHead>
                <TableHead className="text-white font-semibold">CAE estimada</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((row, i) => (
                <TableRow
                  key={i}
                  className={i % 2 === 0 ? "bg-white" : "bg-slate-50"}
                  data-testid={`table-row-${i}`}
                >
                  <TableCell className="font-semibold text-slate-900">
                    {row.monto}
                  </TableCell>
                  <TableCell className="text-slate-700">{row.plazo}</TableCell>
                  <TableCell className="text-slate-700">{row.tasa}</TableCell>
                  <TableCell className="text-slate-700">{row.cae}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        <p className="mt-5 text-xs text-slate-500 leading-relaxed">
          Plazo mínimo legal de operaciones de crédito: 61 días. Las condiciones
          aquí expuestas son meramente referenciales y pueden variar según la
          política de riesgo de cada entidad financiera y el perfil del cliente.
        </p>
      </div>
    </section>
  );
}
